import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'of-app-unavailable',
  imports: [],
  template: `
    <div class="of-error-page">
      <div
        class="card border shadow-sm bg-body overflow-hidden"
        style="--bs-card-border-radius: 0.9rem; max-width: 480px; width: 100%;"
      >
        <div class="card-header bg-transparent d-flex align-items-center gap-2 py-3">
          <i class="bi bi-plug text-warning fs-5"></i>
          <h6 class="mb-0 fw-semibold">Service Unavailable</h6>
        </div>
        <div class="card-body d-flex flex-column gap-3 py-4 px-4">
          <p class="text-muted mb-0 small">
            The backend is currently unavailable. This may be due to maintenance or a temporary outage. Please try again
            shortly.
          </p>
          <p class="text-muted mb-0 small">
            If the problem persists, contact
            <a href="mailto:it-support@cigp.com" class="text-primary">it-support&#64;cigp.com</a>.
          </p>
          <div class="d-flex gap-2 mt-1">
            <button class="btn btn-sm btn-primary" (click)="retry()">
              <i class="bi bi-arrow-clockwise me-1"></i>Retry
            </button>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: []
})
export class AppUnavailableComponent {
  private readonly router = inject(Router);

  retry(): void {
    this.router.navigate(['/']);
  }
}
